import { render, staticRenderFns } from "./WakafKelompok.vue?vue&type=template&id=2b2640f0"
import script from "./WakafKelompok.vue?vue&type=script&lang=js"
export * from "./WakafKelompok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports